import { defineStore } from 'pinia'

export const useTokenStore = defineStore('tokenStore', {
  state: () => ({
    token: '',
    content: {
      items: [],
    },
  }),
  actions: {
    async updateToken() {
      const res = await getToken({ device_name: navigator.appVersion })
      this.token = res.token
    },
    updateContent(content) {
      this.content = content
    },
  },
  persist: true,
})
